class RecentlyViewedProducts extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
    this.currentProductId = parseInt(this.dataset.currentProductId) || null;
    this.limit = parseInt(this.dataset.limit) || 4;
    this.storageKey = 'solow:recently-viewed';
  }

  connectedCallback() {
    this.loadRecentlyViewed();
  }

  getStoredItems() {
    try {
      return JSON.parse(localStorage.getItem(this.storageKey)) || [];
    } catch (e) {
      return [];
    }
  }

  async loadRecentlyViewed() {
    const items = this.getStoredItems()
      .filter((item) => item.id !== this.currentProductId)
      .slice(0, this.limit);

    if (items.length === 0) {
      this.closest('.recently-viewed-section')?.remove();
      return;
    }

    // Preserve preview_theme_id for draft/unpublished theme testing
    const urlParams = new URLSearchParams(window.location.search);
    const previewThemeId = urlParams.get('preview_theme_id');
    const extraParams = previewThemeId ? `&preview_theme_id=${previewThemeId}` : '';

    const results = await Promise.allSettled(
      items.map((item) =>
        fetch(`/products/${item.handle}?sections=recently-viewed-products${extraParams}`).then((response) => {
          if (!response.ok) throw new Error(response.status);
          return response.json();
        })
      )
    );

    const grid = this.querySelector('[data-recently-viewed-grid]');
    let cardsAdded = 0;

    results.forEach((result) => {
      if (result.status !== 'fulfilled') return;
      const sectionHtml = result.value['recently-viewed-products'];
      if (!sectionHtml) return;
      const html = document.createElement('div');
      html.innerHTML = sectionHtml;
      const template = html.querySelector('template[data-recently-viewed-card]');
      if (template) {
        grid.appendChild(template.content.cloneNode(true));
        cardsAdded++;
      }
    });

    if (cardsAdded > 0) {
      this.closest('.recently-viewed-section')?.classList.add('recently-viewed--loaded');
    } else {
      this.closest('.recently-viewed-section')?.remove();
    }
  }
}

customElements.define('recently-viewed-products', RecentlyViewedProducts);
